import React from 'react';

const financial = (
       <img key='img1' src="https://res.cloudinary.com/dwvrok1le/image/upload/v1547316556/contract.png" alt="Financial"/>
    )
const textBubble = (
       <img key='img2' src="https://res.cloudinary.com/dwvrok1le/image/upload/v1547316948/comment-white-oval-bubble.png" alt="Text Bubble"/>
    )
const list = (
       <img key='img3' src="https://res.cloudinary.com/dwvrok1le/image/upload/v1547317083/list.png" alt="List"/>
    )
const scroll = (
       <img key='img4' src="https://res.cloudinary.com/dwvrok1le/image/upload/v1547317202/ancient-scroll.png" alt="scroll"/>
    )
const home = (
       <img key='img5' src="https://res.cloudinary.com/dwvrok1le/image/upload/v1547317620/home.png" alt="home"/>
    )
const request = (
       <img key='img6' src="https://res.cloudinary.com/dwvrok1le/image/upload/v1547317715/phone-call.png" alt="request"/>
    )


export const IMAGE = {
    financial,
    textBubble,
    list,
    scroll,
    home,
    request
}


// WEBPACK FOOTER //
// ./src/utils/images/links.js